// eslint-disable-next-line no-restricted-imports
import UISelect from 'UIComponents/input/UISelect';
import { localeI18nText } from '../utils/localeI18nText';
import useLocaleContext from '../hooks/useLocaleContext';

/*
 * Atm Trellis Select component does not have a transparent select option, we need this
 * for the lang select.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const Select = props => {
  const {
    locale
  } = useLocaleContext();
  return /*#__PURE__*/_jsx(UISelect, Object.assign({
    placeholder: localeI18nText('app.selectComponents.placeholder', locale),
    searchPlaceholder: localeI18nText('app.selectComponents.searchPlaceholder', locale),
    noResultsText: localeI18nText('app.selectComponents.noResults', locale)
  }, props));
};